module.exports = __webpack_public_path__ + "static/img/img-dg3.cf05d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-dg3.png
// module id = GewJ
// module chunks = 0